
    var riot = require('riot')
    
riot.tag2('mail-sample', '<div class="mail-sample"><a href="javascript:void(0);" onclick="{showSample}">メールサンプルはこちら</a></div> <div id="js-modal"> <div class="mail-sample__modal"> <div class="modal__close"><a class="js-fancy-close" href="javascript:void(0);"><i class="ion-android-close"></i></a></div> <div class="mail-sample__body"> <riot-md html="{setSample()}"></riot-md> </div> </div> </div>', '', '', function(opts) {
    const self = this
    self.mail = require('../../json/mail.json').sample

    const replacer = (str) => {
      return str.replace(/\n/g, '<br>')
    }

    this.setSample = function() {
      switch (opts.type) {
        case 'has-class':
          return replacer(self.mail.hasClass)
        case 'no-class':
          return replacer(self.mail.noClass)
        case 'password':
          return replacer(self.mail.password)
        default:
          return false
      }
    }.bind(this)

    this.showSample = function() {
      $.fancybox({
        content: $("#js-modal", self.root).html(),
        closeBtn: false,
        padding: 0,
      })
    }.bind(this)
});
    
  


// WEBPACK FOOTER //
// ./_src/riot/mail-sample/mail-sample.tag